export default function isRequired(str, text) {
    return !text ? !!str || "This field is required" : !!str || text;
    // if(regex.test(str))
}